module.exports = __webpack_public_path__ + "static/media/hvammsvirkjun1200.cc551568.webp";